// extracted by mini-css-extract-plugin
module.exports = {"Arcade_subtitle":"styles_Arcade_subtitle__F1uGi"};